import { render, staticRenderFns } from "./NewProcessDialog.vue?vue&type=template&id=4cd8fa6c"
import script from "./NewProcessDialog.vue?vue&type=script&lang=js"
export * from "./NewProcessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports